import registerBootstrapVueComponents from 'src/config/setup/components/bootstrap.js'
import registerOtherComponents from 'src/config/setup/components/others.js'
import registerSduiComponents from 'src/config/setup/components/sdui.js'

export default function registerComponents(app) {
  registerBootstrapVueComponents(app)
  registerOtherComponents(app)
  registerSduiComponents(app)
}
